<template>
  <div class="catalog-menu-listing-component cmlc ml-0">
    <div v-if="CatalogIsLoading">
      <loading-spinner />
    </div>
    <div v-else class="cmlc__nav">
      <ul class="cmlc__ul">
        <li v-for="category in authorizedCategories" :key="category.Id" class="cmlc__li">
          <router-link
            class="cmlc__link block-100 hmmc__menu-item"
            :to="{ name: 'CatalogListing', query: {currentCategoryId: category.Id.toString()}}"
            @mouseover.native="AttemptSetCurrentCatalog(category.Id)"
            @mouseenter.native="SetHoveringCategoryId(category.Id)"
            @mouseleave.native="SetHoveringCategoryId(-1)"
          >
            {{ category.Title }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import { mapGetters }               from "vuex"
  import { CatalogService }           from "@/services/CatalogService"
  import { ErrorLogService }          from "@/services/ErrorLogService"
  import LoadingSpinner               from "@/components/Elements/LoadingSpinner"
  import { siteSectionsHelper }       from "@/components/mixins/siteSectionsHelper"
  import { brandAndRegionAuthHelper } from "@/components/mixins"

  export default {
    components: {
      LoadingSpinner
    },
    mixins: [siteSectionsHelper, brandAndRegionAuthHelper],
    props: {
      currentCatalog: {
        name: "",
        link: "",
        id: undefined,
        childCategories: []
      }
    },

    data: function() {
      return {
        categories: [],
        hoveringCategoryId: 0,
        megaMenuHoverDelay: 250
      }
    },
    computed: {
      ...mapGetters(["user", "activeAccountId", "CatalogRoot", "CatalogIsLoading"]),
      authorizedCategories() {
        if(this.CatalogIsLoading || !this.CatalogRoot){
          return [];
        }

        var authCategories = this.CatalogRoot.filter(x =>
          this.IsBrandRegionAuthorized(x.BrandAuth, x.RegionAuth)
        );
        return authCategories;
      },
    },
    updated(){
      this.SetInitialCurrentCatalog();
    },
    methods: {
      AttemptSetCurrentCatalog: function (categoryId) {
        let self = this
        setTimeout(function(){
          if(self.hoveringCategoryId === categoryId){
            self.SetCurrentCatalog(categoryId);
          }
        }, self.megaMenuHoverDelay);

      },
      SetInitialCurrentCatalog: function(){
        let initialCategory = this.authorizedCategories[0];
        if(initialCategory)
        {
          this.SetCurrentCatalog(initialCategory.Id);
        }
      },
      SetCurrentCatalog: function(categoryId){
        let passedCategory = this.CatalogRoot.find(x => x.Id === categoryId);
        if(passedCategory)
        {
          this.currentCatalog.id = passedCategory.Id
          this.currentCatalog.name = passedCategory.Title
          this.currentCatalog.link = `/Catalog/catalogListing?currentCategoryId=${passedCategory.Id}`
        }
      },
      SetHoveringCategoryId: function (categoryId) {
        this.hoveringCategoryId = categoryId
      }
    }
  }
</script>


<style lang="scss">
.cmlc {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}
.cmlc__li {
}
.cmlc__li:last-child {
  margin-bottom: 4px;
}
.cmlc__ul{
  list-style: none;
  padding-left: 0px;
  margin-bottom: 0;
  font-size: 15px;
  line-height: 1;
}
.cmlc__link {
  padding: 4px 2px;
  border-radius: 4px;
  font-weight: normal;
  overflow-wrap: break-word;
  text-shadow: none;
  color: $brand;
  transition: background-color 0.15s ease, color 0.15s ease;
  &:hover {
    color: #fff;
    background-color: $brand;
    text-decoration: none;
  }
}
.cmlc__nav{
  flex: 1 1 auto;
  min-height: 0;
  padding: 0px 6px;
  background-color: #e0eaf3;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  text-align: left;
}

</style>
